/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export const Position2D = {
  ABOVE: "above",
  BELOW: "below",
  LEFT: "left",
  RIGHT: "right"
};

export const DEFAULT_POSITION_PRIORITY = [Position2D.ABOVE, Position2D.BELOW, Position2D.LEFT, Position2D.RIGHT];

export const PositionPriority = [Position2D.ABOVE, Position2D.BELOW, Position2D.LEFT, Position2D.RIGHT];

export const StringXPosition = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center"
};

export const StringYPosition = {
  TOP: "top",
  BOTTOM: "bottom",
  CENTER: "center"
};

export const EVENTS = {
  SHOW: "show",
  HIDE: "hide",
  DRAG: "drag",
  DRAG_START: "dragStart",
  DRAG_END: "dragEnd",
  MOVE: "moveTo",
  DESTROY: "destroy",
  ANIMATION: "triggerAnimation",
  CLASS_NAME_OVERRIDE: "overrideClassName",
  CSS_OVERRIDE: "overrideCSS",
  UPDATE_COMPONENT: "updateComponent",
  TOGGLE_DRAGGABLE: "toggleDraggable",
  TOGGLE_CLOSE_BTN: "toggleCloseBtn",
  TOGGLE_SCROLL: "toggleScroll"
};

export const ANIMATION_NAMES = {
  SHAKE: "shake"
  // Add more animations as needed
};
